export enum MediaTypes {
  IMAGE = 'IMAGE',
  VIDEO = 'VIDEO',
  SOUND = 'SOUND',
  DOCUMENT = 'DOCUMENT',
}
